function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ControlMessage = /*#__PURE__*/function () {
  function ControlMessage(s, t) {
    _classCallCheck(this, ControlMessage);

    this.triggerId = s, this.messageExtras = t, this.triggerId = s, this.messageExtras = t, this.extras = {}, this.isControl = !0, this.Ht = !1;
  }

  _createClass(ControlMessage, [{
    key: "_t",
    value: function _t() {
      return !this.Ht && (this.Ht = !0, !0);
    }
  }, {
    key: "Bo",
    value: function Bo() {
      return this.Ht;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(s) {
      return new ControlMessage(s.trigger_id, s.message_extras);
    }
  }]);

  return ControlMessage;
}();

export { ControlMessage as default };